import './style.less';
import angular from 'angular';
import { orderBy } from 'lodash';

export default function($log, $state, $stateParams, Swal, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.profile_uid = $stateParams.id;
  vm.forms = [];

  const { profile_uid, company_id } = ProfileClass.profileComplete.profile;

  vm.addForm = () => {
    vm.btnCreate = true;
    ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'evaluationForms' }, {})
      .then(({ data: { item: { form_id } } }) => {
        vm.btnCreate = false;
        $state.go('app.author.evaluationForms.evaluationForm.edit', { id: vm.profile_uid, form_id });
      })
      .catch(error => {
        vm.btnCreate = false;
        $log.error(error);
        throw error;
      });
  };

  vm.duplicateForm = form => {
    const formTemplate = angular.copy(form);
    formTemplate.name += ' - Copy';
    ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'evaluationForms' }, formTemplate)
      .then(({ data: { item: { form_id } } }) => {
        Swal.toast('Evaluation form duplicated!');
        $state.go('app.author.evaluationForms.evaluationForm.edit', { id: vm.profile_uid, form_id });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.archiveForm = id => {
    return ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'evaluationForms', type_id: id },
      { archive: true }
    )
      .then(({ data: { item } }) => {
        Swal.toast('Archived!, Your evaluation form has been archived.');
        vm.forms.forEach((form, i) => {
          if (form.form_id === item.form_id) vm.forms.splice(i, 1);
        });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    vm.loaded = false;
    vm.error = {};

    ApiClass.companiesIdTypeGet({ manage: true, id: company_id, type: 'evaluationForms' }, null)
      .then(({ data: { items: evaluations } }) => {
        $log.debug(arguments);
        const forms = angular.copy(evaluations).filter(({ archive, edit }) => !archive && edit !== false);
        vm.forms = orderBy(forms, ['name', 'active'], ['asc', 'desc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/evaluationForms/get/controller.js